import styled from 'styled-components'

import { fromMd, untilMd } from '@syconium/little-miss-figgy'

import {
  NextDialog,
  NextDialogBody,
  NextDialogDismiss,
  NextDialogTrigger,
} from '../../../app/_components/dialogs/NextDialog.client'
import * as Review from '../Review.styles'

/* Top-level dialog container */
export const Dialog = styled(NextDialog)`
  min-width: unset;

  /* Override default border radius */
  border-radius: 8px;

  ${untilMd} {
    width: 373px;
  }

  ${fromMd} {
    width: 90vw;
    flex-direction: row;
    max-width: 902px;
  }
`

/* Container for inner dialog content */
export const DialogContent = styled(NextDialogBody)`
  text-align: left;
  position: relative;
  height: 100%;
  padding: ${o => o.theme.spacing(6, 4)};
  display: flex;
  padding: 0;
  flex-direction: column;
  ${fromMd} {
    flex-direction: row;
  }
`

/* Container for close button */
export const CloseButtonWrapper = styled.div<{ displayOnMobile: boolean }>`
  display: none;

  ${untilMd} {
    justify-items: end;
    z-index: 10;
    height: 100%;

    padding: ${o => o.theme.spacing(4)};
    display: ${o => (o.displayOnMobile ? 'block' : 'none')};
  }

  ${fromMd} {
    margin: ${o => o.theme.spacing(6)};
    display: ${o => (o.displayOnMobile ? 'none' : 'flex')};
    justify-content: end;
  }
`

/* Dismiss button for the dialog */
export const CloseButton = styled(NextDialogDismiss)`
  cursor: pointer;
  display: flex;
  width: 24px;
  height: 24px;
  justify-content: space-evenly;
  align-items: center;
`

export const SwiperWrapper = styled.div`
  max-width: 373px;
  width: 100%;
  height: 100%;
  display: flex;
  order: 1;

  ${untilMd} {
    margin-bottom: ${o => o.theme.spacing(6)};
  }

  ${fromMd} {
    order: 0;
  }
`

export const ReviewWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${untilMd} {
    order: 3;
  }
`

/**
 * Used to wrap 'review' content (stars, title, date, content)
 */
export const ReviewContent = styled.div`
  padding: 0 ${o => o.theme.spacing(6, 6, 6)};
  ${untilMd} {
    padding: 0 ${o => o.theme.spacing(4, 4, 4)};
  }
`

/**
 * Used to wrap 'reviewer' content (name, height, weight, fit, occupation, size purchased).
 */
export const PurchaseDetailsWrapper = styled(Review.PurchaseDetailsWrapper)`
  margin-top: ${o => o.theme.spacing(6)};
`

export const PurchaseDetails = styled(Review.PurchaseDetails)`
  padding: ${o => o.theme.spacing(6.25)};
`

/**
 * Contains `StarRating` and `CreatedAtDate` content.
 */
export const Header = styled(Review.Header)``

export const CreatedAtDate = styled(Review.CreatedAtDate)``

export const Title = styled(Review.Title)`
  margin-top: ${o => o.theme.spacing(2)};
`

export const BodyText = styled(Review.BodyText)`
  margin-top: ${o => o.theme.spacing(2)};
`

export const ReviewerName = styled(Review.ReviewerName)`
  margin-bottom: ${o => o.theme.spacing(2)};
`

export const DetailsItem = styled(Review.DetailsItem)``

export const DetailsList = styled(Review.DetailsList)``

export const ThumbnailTarget = styled(NextDialogTrigger)``
